module.exports = __webpack_public_path__ + "img/single-post-img3-1200x790.ebc19711.jpg";